module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.466825d3.jpg";